<template lang="html">
  <StandardDialog @click-outside="$router.push({ name: 'ConnectCompanyProjects'})">
    <template #content>
      <StandardTextCard
        height="74vh"
        name="Join Company Project"
        :clickable="false"
      >
        <template #info>
          <v-row>
            <v-col cols="3"></v-col>
            <StandardCard
              :image="getBusinessProject(project_id).image"
              :name="getBusinessProject(project_id).name"
              :cols="6"
              clickable="false"
              >
            </StandardCard>
            <v-col cols="3"></v-col>
          </v-row>
        </template>
        <template #actions>
          <v-btn color="blue" text
            :disabled="!hasBusinessPermission('Join Projects')"
            @click="joinProjectAsObserver({
              business_id: getBusiness.id,
              payload: { project_id: project_id }
            })">Join Project as Observer</v-btn>
          <v-btn color="red" text @click="$router.push({ name: 'ConnectCompanyProjects'})">Cancel</v-btn>
          <span v-if="!hasBusinessPermission('Join Projects')">You can't join the projects, because you don't have the permission</span>
        </template>
      </StandardTextCard>
    </template>
  </StandardDialog>
</template>

<script>
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue';
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import StandardCard from '@/components/StandardComponents/StandardCard.component.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'CompanyJoinProject',
  components: {
    StandardTextCard, StandardDialog, StandardCard
  },
  props: ['project_id'],
  data: function () {
    return {
      selection: []
    }
  },
  computed: {
    ...mapGetters('Business', [
      'getBusiness',
      'getBusinessProject',
      'hasBusinessPermission'
    ])
  },
  methods: {
    ...mapActions('Business', [
      'joinProjectAsObserver'
    ])
  }
}
</script>

<style lang="scss" scoped>
</style>
